import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  en: {
    common: require('./en.json'),
  },
  es: {
    common: require('./es.json'),
  },
}

i18n
  .use(initReactI18next)

i18n
  .init({
    resources,
    fallbackLng: 'es',
    preload: ['es', 'en'],
    defaultNS: 'common',
    fallbackNS: 'common',
    detection: {
      order: ['path'],
    },
    nsSeparator: false,
    keySeparator: false,
  })

export default i18n
